<template>
    <div class="purchase_part my-2">
        <cabinet-fl44-card-header :purchase="contract" />
        <cabinet-fl44-card-subheader :purchase="contract" />
        <cabinet-fl44-card-body>
            <template v-slot:col1>
                <cabinet-notice-card-row-single v-if="contract.purchase_info.planned_contract_execution_date" label="Планируемая дата исполнения">
                    {{ getDateFormat(contract.purchase_info.planned_contract_execution_date) }}
                </cabinet-notice-card-row-single>
                <cabinet-notice-card-row-single v-if="isContractConcluded" label="Контракт заключен">
                    {{ getDateFormat(contract.purchase_info.contract_date) }}
                </cabinet-notice-card-row-single>
                <cabinet-notice-card-row-single v-if="contract.purchase_info.contract_price" label="Цена контракта"> {{ $formatPrice(contract.purchase_info.contract_price) }} руб. </cabinet-notice-card-row-single>
                <cabinet-notice-card-row-single v-if="contract.purchase_info.contract_price_with_supplementary_agreement" label="Цена контракта с учётом ДС"> {{ $formatPrice(contract.purchase_info.contract_price_with_supplementary_agreement) }} руб. </cabinet-notice-card-row-single>
                <purchase-comment-edit-block v-if="contract.flags.is_customer" :purchase="contract" type="fl44_unknown_volume" @refresh="refresh" />
            </template>
            <template v-slot:col2>
                <cabinet-notice-card-row-dual v-if="contract.purchase_info.deliverable_group_name" label="Предмет закупки">
                    {{ contract.purchase_info.deliverable_group_name }}
                </cabinet-notice-card-row-dual>
                <cabinet-notice-card-row-dual v-if="contract.flags.is_supplier" label="Заказчик">
                    <router-link :to="{ name: 'OrganizationShow', params: { id: contract.customer.id } }" class="system_link-style" target="_blank">
                        {{ contract.customer.name }}
                    </router-link>
                </cabinet-notice-card-row-dual>
                <cabinet-notice-card-row-dual v-if="contract.flags.is_customer" label="Поставщик">
                    <router-link :to="{ name: 'OrganizationShow', params: { id: contract.supplier.id } }" class="system_link-style" target="_blank">
                        {{ contract.supplier.name }}
                    </router-link>
                </cabinet-notice-card-row-dual>
                <cabinet-notice-card-row-single label="Количество позиций">{{ contract.purchase_info.deliverables_count }} </cabinet-notice-card-row-single>
                <cabinet-notice-card-row-dual v-if="contract.purchase_info.delivery_addresses && contract.purchase_info.delivery_addresses.length" label="Адреса для доставки товаров/выполнения работ/оказания услуг">
                    <p v-for="(address, index) in contract.purchase_info.delivery_addresses" :key="`${index}_${address.address}`" class="fs-12 m-0 grey-color fw-600">&mdash;&nbsp;{{ address.address }}</p>
                </cabinet-notice-card-row-dual>
            </template>
            <template v-slot:col3>
                <cabinet-fl44-card-info-link :to="{ name: 'Fl44UnknownVolumePurchaseShow', params: { id: contract.id } }" icon="search">Информация о закупке</cabinet-fl44-card-info-link>
                <cabinet-fl44-card-info-link :to="{ name: 'Fl44UnknownVolumePurchaseShow', params: { id: contract.id }, hash: '#atmo-supplier-info' }" icon="small_helmet">Итоговый протокол </cabinet-fl44-card-info-link>
                <cabinet-fl44-card-info-link :to="{ name: 'Fl44UnknownVolumePurchaseShow', params: { id: contract.id }, hash: '#atmo-contract' }" icon="grey_contract">Контракт</cabinet-fl44-card-info-link>
                <cabinet-fl44-card-info-link :to="{ name: 'Fl44UnknownVolumePurchaseShow', params: { id: contract.id }, hash: '#atmo-contract-fulfillment' }" icon="grey_file_small">Исполнение контракта</cabinet-fl44-card-info-link>

                <cabinet-fl44-notice-card-rate-button :contract="contract" @refresh="refresh" />
                <b-button :to="{ name: 'Fl44UnknownVolumePurchaseShow', params: { id: contract.id }, hash: '#second-proposal-contract' }" exact target="_blank" class="btn btn-card-action btn-card-action-danger my-1" v-if="contract.actions.allow_second_proposal_contract">
                    Отправить контракт второму поставщику
                </b-button>
                <b-button v-if="contract.actions.customer_need_sign_second_proposal_contract" class="btn btn-card-action btn-card-action-danger my-1" exact target="_blank" :to="{ name: 'Fl44UnknownVolumePurchaseShow', params: { id: contract.id }, hash: '#atmo-contract' }">
                    Подписать контракт
                </b-button>
                <b-button v-if="contract.actions.customer_need_answer_dispute" :to="{ name: 'Fl44UnknownVolumePurchaseShow', params: { id: contract.id }, hash: '#atmo-disputes-resolution' }" exact target="_blank" class="btn btn-card-action btn-card-action-danger my-1">
                    Ответить на протокол разногласий
                </b-button>
                <cabinet-fl44-notice-card-copy-button :purchase="contract" />
                <b-button
                    v-if="contract.actions.customer_need_answer_supplementary_agreement_dispute"
                    class="btn btn-card-action btn-card-action-danger my-1"
                    exact
                    target="_blank"
                    v-bind:to="{ name: 'Fl44UnknownVolumePurchaseShow', params: { id: contract.id }, hash: '#atmo-disputes-resolution' }"
                    >Ответить на протокол разногласий
                </b-button>
                <b-button
                    v-if="contract.actions.customer_need_sign_supplementary_agreement || contract.actions.provider_need_sign_supplementary_agreement"
                    class="btn btn-card-action btn-card-action-danger my-1"
                    exact
                    target="_blank"
                    v-bind:to="{ name: 'Fl44UnknownVolumePurchaseShow', params: { id: contract.id }, hash: '#atmo-contract-annexes' }"
                    >Подписать дополнительное соглашение
                </b-button>
            </template>
        </cabinet-fl44-card-body>
    </div>
</template>

<script>
import PurchaseCommentEditBlock from '@/components/common/purchase-comment-edit-block';
import CabinetNoticeCardRowDual from '@/components/cabinet/partials/cabinet-notice-card-row-dual.vue';
import CabinetNoticeCardRowSingle from '@/components/cabinet/partials/cabinet-notice-card-row-single.vue';
import CabinetFl44CardHeader from '@/components/cabinet/fl44/cards/partials/cabinet-fl44-card-header.vue';
import CabinetFl44CardBody from '@/components/cabinet/fl44/cards/partials/cabinet-fl44-card-body.vue';
import CabinetFl44CardSubheader from '@/components/cabinet/fl44/cards/partials/cabinet-fl44-card-subheader.vue';
import CabinetFl44NoticeCardRateButton from '@/components/cabinet/fl44/cards/partials/cabinet-fl44-notice-card-rate-button.vue';
import CabinetFl44NoticeCardCopyButton from '@/components/cabinet/fl44/cards/partials/cabinet-fl44-notice-card-copy-button.vue';
import CabinetFl44CardInfoLink from '@/components/cabinet/fl44/cards/partials/cabinet-fl44-card-info-link.vue';

export default {
    name: 'cabinet-fl44-unknown-volume-purchase-contract-card',
    props: {
        contract: {
            type: Object,
            required: true
        }
    },
    components: {
        CabinetFl44CardInfoLink,
        CabinetFl44NoticeCardCopyButton,
        CabinetFl44NoticeCardRateButton,
        CabinetFl44CardSubheader,
        CabinetFl44CardBody,
        CabinetFl44CardHeader,
        CabinetNoticeCardRowSingle,
        CabinetNoticeCardRowDual,
        PurchaseCommentEditBlock
    },
    methods: {
        refresh() {
            this.$emit('refresh');
        }
    },
    computed: {
        isContractConcluded() {
            return ['contract:active', 'contract:fulfilled', 'contract:unfulfilled', 'contract:terminated'].includes(this.contract.status.id);
        }
    }
};
</script>

<style scoped>
.purchase_part {
    background: #fff;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
    border: 1px solid #d9d9de;
}
</style>
